import React from 'react';
import { Roles } from '../../../../../common/src/enums/Roles';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetch } from '../../../store/openApiFetch';
import { useOpenApiFetch } from '../../../store/useOpenApiFetch';
import { IconEditLink } from '../../common/iconButtons/IconEditLink';
import { IconRemoveButton } from '../../common/iconButtons/IconRemoveButton';
import {
    Content,
    Panel,
    PanelBody,
    PanelCreateLink,
    Table,
    TableBody,
    TableButtons,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../../elements';
import { Spinner } from '../../spinners';
import { useUserHasRole } from '../../utils/authorization/useUserHasRole';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ObjectTypeFieldList(props: { params: { objectTypeId: string } }) {
    const { objectTypeId } = props.params;
    const translate = useTranslate();
    const { userHasRole } = useUserHasRole();
    const isAdmin = userHasRole([Roles.Administrator]);

    const { data, reload, isLoading } = useOpenApiFetch('/api/objectTypes/{objectTypeId}/objectTypeFields', 'get', { objectTypeId });

    async function remove(objectTypeFieldId: string) {
        await openApiFetch(
            '/api/objectTypes/{objectTypeId}/objectTypeFields/{objectTypeFieldId}',
            'delete',
            { objectTypeId, objectTypeFieldId },
            undefined,
        );
        await reload();
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title={translate('objectTypeField.objectTypeFields')} icon="fa-cogs" />
                </TopbarLeft>
                <TopbarRight>
                    <PanelCreateLink
                        to={`/settings/objecttypes/${objectTypeId}/objectTypeFields/add`}
                        text={translate('common.addItem', translate('objectTypeField.objectTypeField'))}
                    />
                </TopbarRight>
            </Topbar>
            <Content>
                <Tray>
                    <Panel>
                        {(isLoading && <Spinner />) || (
                            <PanelBody noPadding={true}>
                                <Table>
                                    <TableHead>
                                        <TableHeadRow light={true}>
                                            <TableHeader>{translate('common.name')}</TableHeader>
                                            <TableHeader>{translate('common.category')}</TableHeader>
                                            {isAdmin && <TableHeader>{translate('common.company')}</TableHeader>}
                                            <TableHeader>&nbsp;</TableHeader>
                                        </TableHeadRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.items &&
                                            data.items.map((item) => (
                                                <TableRow key={item.id}>
                                                    <TableData> {item.name} </TableData>
                                                    <TableData> {item.category} </TableData>
                                                    {isAdmin && <TableData> {item.clientCompany.name} </TableData>}
                                                    <TableButtons large>
                                                        <IconEditLink to={`/settings/objecttypes/${objectTypeId}/objectTypeFields/${item.id}/edit`} />
                                                        <IconRemoveButton
                                                            removeQuestion={translate('common.confirmDelete', item.name)}
                                                            onClick={async () => remove(item.id)}
                                                        />
                                                    </TableButtons>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </PanelBody>
                        )}
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
